import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {ModalHeaderComponent} from '../../../layout/modal-header/modal-header.component';

@Component({
    selector: 'app-info-auth-token',
    templateUrl: './info-auth-token.component.html',
    styleUrls: ['./info-auth-token.component.scss'],
    imports: [ModalHeaderComponent, MatDialogContent]
})
export class InfoAuthTokenComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<InfoAuthTokenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      token?: string,
    },
  ) { }

  ngOnInit(): void {
  }

}
